import React from "react";
import { cn } from "@/utils/utils";

interface PageContainerProps {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly maxWidth?: "default" | "narrow" | "wide" | "full";
  readonly noPadding?: boolean;
}

/**
 * Container padrão para páginas da aplicação
 * Garante largura máxima consistente e padding padrão
 *
 * Larguras disponíveis:
 * - default: max-w-7xl (1280px) - Padrão para maioria das páginas
 * - narrow: max-w-4xl (896px) - Para páginas de formulário/conteúdo focado
 * - wide: max-w-[1440px] - Para dashboards com muito conteúdo
 * - full: sem limite - Para páginas que precisam largura total
 */
export function PageContainer({
  children,
  className,
  maxWidth = "default",
  noPadding = false,
}: PageContainerProps) {
  const maxWidthClasses = {
    default: "max-w-7xl", // 1280px - Padrão
    narrow: "max-w-4xl", // 896px - Conteúdo focado
    wide: "max-w-[1440px]", // 1440px - Dashboards
    full: "max-w-full", // Sem limite
  };

  const paddingClasses = noPadding ? "" : "px-4 py-6";

  return (
    <div
      className={cn(
        maxWidthClasses[maxWidth],
        "mx-auto",
        paddingClasses,
        className,
      )}
    >
      {children}
    </div>
  );
}
